<template>
<div>
  <span v-if="debug === 'true' || debug === true">{{version}}</span>
  <Header v-if="!props"/>
  <loading
      :active.sync="loading"
      :can-cancel="false"
      :is-full-page="true"
  ></loading>
  <b-card class="bCardAgenda">
    <b-container fluid="">
      <b-row class="divSubtitulo m-1 mb-3">
        <b-col cols="6" md="8">
          <div>
            <p class="textoSubtitulo">Impresión pti</p>
          </div>
        </b-col>
        <b-col cols="6" md="4">
          <div>
            <p style="text-align:end" class="textoSubtitulo">Impresion_v5</p>
          </div>
        </b-col>
      </b-row>
    </b-container>

    <div v-if="opcion != null">
      <loading :active.sync="loaderImprimir" :can-cancel="false" :is-full-page="true"></loading>
      <div class="text-center">
        <b-button v-if="$localStorageService.can('UP_Inversion_imprimir_PTI')" class="mr-5" variant="outline-warning" v-on:click="imprimir" :disabled="seLlenoPdf && loaderImprimir">
          <b-icon icon="printer"></b-icon><span class="ml-1" v-if="!loaderImprimir">Imprimir</span>
          <b-spinner small v-else label="Spinning"></b-spinner>
        </b-button>

        <b-button class="mr-5" variant="outline-info" @click="abrirModalCorreos()">Enviar por correo</b-button>

        <b-button v-if="!props && origen !== 'paciente'&& origen !== 'CAJA'" variant="outline-primary" @click="irACaja" >
          <b-icon icon="cash-stack"></b-icon> Ir a caja
        </b-button>
      </div>
      <br/>
      <br/>
      <div class="mt-4">
        <div class="text-center">
          <b-spinner variant="primary" v-if="seLlenoPdf" ></b-spinner>
        </div>

        <div style="width: 100%; height: auto; float: left" ref="miAnchoPdf">
        </div>
        <pdf
            v-for="i in numPages"
            :key="i"
            :page="i"
            :src="base64"
            :style="'display: inline-block; height: auto; width: '+ widthPdf + 'px'"
        >
        </pdf>
      </div>
    </div>
    <div v-else>
      <b-alert show variant="warning">No ha aceptado ningún PTI</b-alert>
    </div>


  </b-card>

  <b-modal
      v-model="modalCorreos"
      size="md"
      title="Correo del paciente"
      hide-footer>
    <ContactoPaciente
        :idPaciente="datosPacienteBasico.idPaciente"
        :origen="2"
        @_setearValor="setearValor">
    </ContactoPaciente>
    <div style="text-align: center">
      <b-button class="mt-3" variant="outline-info" @click="enviarCorreo()">
        Enviar
      </b-button>
    </div>

  </b-modal>
</div>


</template>

<script>
import Header from "@/components/Header";
import pdf from "vue-pdf";
import ContactoPaciente from "@/components/paciente/ContactoPaciente.vue";
export default {
  name: "ImpresionPtiv5",
  components: {ContactoPaciente, pdf, Header},
  props: {
    props: {
      type: Boolean,
      default: false
    },
    idPtiProp: Number,
    opcionProp: Number,
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    widthPdf: 500,
    base64: null,
    numPages: 0,
    seLlenoPdf: false,
    datosPacienteBasico: null,
    modalCorreos: false,
    contactoSeleccionado: null,
    loading: false,

    idPti: null,
    opcion: null,
    idSolicitudEtapa: null,
    loaderImprimir: false
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();
    if (this.props) {
      this.idPti = this.idPtiProp;
      this.opcion = this.opcionProp;
    } else {
      this.idPti = this.$route.params.idPti;
      this.opcion = this.$route.params.opcion;
      this.idSolicitudEtapa = this.$route.params.idSolicitudEtapa;
    }

    history.forward();
    this.imprimirEntregable();
    this.obtenerDatosPacienteBasico();
  },
  methods: {
    obtenerDatosPacienteBasico() {
      this.$http.post(this.$api + "paciente/obtenerDatosPacienteBasicoPorPti", this.traerParametrosPaciente()).then(respuesta => {
        if (respuesta.data.data) {
          this.datosPacienteBasico = respuesta.data.data;
        }
      }).catch(error => {
        console.error(error);
      }).finally(() => {
        this.obtenerTratamientosApartados();
      })
    },
    traerParametrosPaciente() {
      const i = new Date();
      i.setDate(i.getDate());
      i.setHours(0, 0, 0, 0);
      const inicio = this.$moment(i).utc().format("YYYY-MM-DD[T]HH:mm:ss[Z]");

      const f = new Date();
      f.setHours(23, 59, 59, 999);
      const fin = this.$moment(f).utc().format("YYYY-MM-DD[T]HH:mm:ss[Z]");

      return {
        idPti: this.idPti,
        idUsuario: this.$localStorageService.getIdUsuario(),
        horaInicio: inicio,
        horaFin: fin,
        presentacion: true,
        idClinica: this.$localStorageService.getIdClinica()
      };
    },
    abrirModalCorreos(){
      this.modalCorreos = true;
    },
    setearValor(valor) {
      this.contactoSeleccionado = valor;
    },
    enviarCorreo(){
      if (this.contactoSeleccionado === null) {
        this.$swal({
          icon: "warning",
          text: "Debes seleccionar un correo para enviar el documento",
          confirmButtonText: "OK",
          confirmButtonColor: "#0e6ba9",
        });
        return false;
      }
      this.loading = true;
      let params = {
        idContacto: this.contactoSeleccionado,
        idPti: this.idPti,
        idSolicitud: this.$route.params.idSolicitud,
        idSolicitudEtapa: this.idSolicitudEtapa,
        opcion: this.opcion,
        clasificacion: 1,
        idEtapa: this.$route.params.idEtapa == 100 ? 100 : 89,
        idClinica: this.$localStorageService.getIdClinica(),
        correoAutomatico: false,
        agruparPorOd: false
      }
      this.$http.post(this.$api + "procesoPtiV5/enviarCorreoEntregablePTI", params).then((response) => {
        if(response.data.data){
          this.$swal.fire({
            icon: "success",
            title: "Correo enviado",
            text: "Se envió el correo correctamente",
            showConfirmButton: false,
            timer: 3500,
          });
        }
      }).catch((err) => {
        console.error(err);
        this.$swal.fire({
          icon: "error",
          title: "Error",
          text: "Ocurrió un error al enviar el correo, por favor inténtelo más tarde",
        });
      }).finally(() => {
        this.modalCorreos = false;
        this.loading = false;
      });
    },
    irACaja(){
      this.$router.push({
        name: "dashboard",
      });
      this.guardarImpresionPtiv5();
    },
    guardarImpresionPtiv5() {
      let params = {
        idPti: this.idPti,
        idSolicitud: this.$route.params.idSolicitud,
        idSolicitudEtapa: this.idSolicitudEtapa,
        opcion: this.opcion,
        clasificacion: 1,
        idClinica: this.$localStorageService.getIdClinica(),
        idEtapa: this.$route.params.idEtapa == 100 ? 100 : 89,
        guardarFoto: true,
        agruparPorOd: false
      }
      this.$http.post(this.$api + 'procesoPtiV5/guardarEntregablePTI', params)
          .then(() => {}
          ).catch((error) => {
        console.error(error);
      })
    },
    imprimirEntregable() {
      this.seLlenoPdf = true;
      let params = {
        idPti: this.idPti,
        idSolicitud: this.$route.params.idSolicitud,
        idSolicitudEtapa: this.idSolicitudEtapa,
        opcion: this.opcion,
        clasificacion: 1,
        idClinica: this.$localStorageService.getIdClinica(),
        idEtapa: this.$route.params.idEtapa == 100 ? 100 : 89,
        guardarFoto: true,
        agruparPorOd: false
      }

      this.$http.post(this.$api + 'procesoPtiV5/imprimirEntregablePTI', params).then(respuesta => {
        if (respuesta.data.data) {
          this.widthPdf = this.$refs.miAnchoPdf.clientWidth;
          this.base64 = "data:application/pdf;base64," + respuesta.data.data;
          this.numPages = 0;

          let pdfDocument = pdf.createLoadingTask(
              "data:application/pdf;base64," + respuesta.data.data
          );
          pdfDocument.promise.then((pdf) => {
            this.numPages = pdf.numPages;
          }).catch((error) => {
            console.error(error);
          });
        }
      }).catch(error => {
        console.error(error);
      }).finally(() => {
        this.seLlenoPdf = false;
      })
    },
    imprimir() {
      this.loaderImprimir = true;

      setTimeout(() => {
        this.downloadPDF();
        this.loaderImprimir = false;
      }, 500);
    },
    downloadPDF() {
      const linkSource = this.base64;
      const downloadLink = document.createElement("a");
      const fecha = this.$moment(new Date()).format('l')
      const newDate = fecha.split("/")
      var dia = newDate[0];
      var mes = newDate[1];
      var anio = newDate[2];

      let fileName;
      if (this.$route.params.idEtapa == 100) {
        fileName = 'Edición M2 ' + this.datosPacienteBasico.nombreCompleto + ' ' + dia + '/' + mes + '/' + anio;
      } else {
        fileName = 'M2 '+this.datosPacienteBasico.nombreCompleto+' '+dia+'/'+mes+'/'+anio;
      }
      downloadLink.href = linkSource;
      downloadLink.download = fileName;
      downloadLink.click();
    },
  }
}
</script>

<style scoped>

</style>
